var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "panel", attrs: { id: "panel_dashboard" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "panel-container show" }, [
      _c(
        "div",
        { staticClass: "panel-content shadow" },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.is_load } },
            [
              _c(
                "b-tabs",
                { attrs: { "content-class": "mt-3" } },
                _vm._l(_vm.tabs, function (tab, index) {
                  return _c(
                    "b-tab",
                    {
                      key: index,
                      attrs: {
                        title: _vm.get_tab_title(tab),
                        active: tab.is_active,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.set_active(index)
                        },
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "title" },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.get_tab_title(tab)) +
                              "\n\t\t\t\t\t\t\t"
                          ),
                          tab.is_load
                            ? _c("b-spinner", {
                                attrs: { type: "grow", small: "" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(tab.index, {
                        tag: "component",
                        attrs: { user_id: parseInt(_vm.user_id) },
                        on: { loading: _vm.set_loading },
                      }),
                    ],
                    2
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "panel-hdr bg-primary-500 bg-success-gradient" },
      [
        _c("h2", [_vm._v("\n\t\t\tМій кабінет\n\t\t")]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-toolbar" }, [
          _c("button", {
            staticClass: "btn btn-panel waves-effect waves-themed",
            attrs: {
              "data-action": "panel-fullscreen",
              "data-toggle": "tooltip",
              "data-offset": "0,10",
              "data-original-title": "Fullscreen",
            },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }